import React, { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import './index.scss'
import App from './App.jsx'
import { persistor, store } from './store/store.js'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { GoogleOAuthProvider } from '@react-oauth/google';
import 'quill/dist/quill.snow.css' // Quan trọng!
import './DetailProduct.scss'
const client_id = '297134669558-t7k2nnfnsdt7eaqnag7b7b66csugrjg8.apps.googleusercontent.com'

createRoot(document.getElementById('root')).render(
  // <StrictMode>
    <Provider store={store}>
      <GoogleOAuthProvider clientId={client_id}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </PersistGate>
      </GoogleOAuthProvider>
    </Provider>
  // </StrictMode> 
)
